import * as React from 'react';
import { FC, useState, useCallback } from 'react';
import useLocalised from 'customHooks/useLocalised/useLocalised';
import { inspiration } from 'data/translationKeys';
import { InspirationType } from 'types/types';
import InspirationList from './InspirationList';
import Button, { FILLED_BUTTON_TYPE } from 'components/Button/Button';
import useMediaQuery from '@mui/material/useMediaQuery';

import { breakpoints } from 'data/constants';

import { view_all } from 'data/translationKeys';
import router from 'next/router';
interface IInspirationItem {
  inspirations: InspirationType[];
}

export type InspirationItemStateType = {
  showAll: boolean;
};

const initialInspirationItemState: InspirationItemStateType = {
  showAll: false,
};

const Inspiration: FC<IInspirationItem> = ({ inspirations }) => {
  const [state, setState] = useState<InspirationItemStateType>(
    initialInspirationItemState
  );

  const inspiration_text = useLocalised(inspiration);
  const view_all_text = useLocalised(view_all);
  const isMobile = useMediaQuery(`(max-width:${breakpoints.sm})`);

  const handleClickOnViewAll = useCallback(() => {
    setState(state => ({
      ...state,
      showAll: true,
    }));
  }, []);

  const handleClick = (inspiration: InspirationType) => {
    router.push({
      pathname: '/search-results-inspirations/[inspirationId]',
      query: { inspirationId: inspiration.id },
    });
  };

  return (
    <div className="inspiration">
      <div className="inspiration__title">
        <h2>{inspiration_text}</h2>
      </div>
      <div>
        {isMobile ? (
          <div>
            {state.showAll ? (
              <div className="inspiration__outerWrapper">
                {inspirations.map((inspiration, index) => (
                  <div key={index} onClick={() => handleClick(inspiration)}>
                    <InspirationList inspiration={inspiration} />
                  </div>
                ))}
              </div>
            ) : (
              <div className="inspiration__outerWrapper">
                {inspirations.slice(0, 4).map((inspiration, index) => (
                  <div key={index} onClick={() => handleClick(inspiration)}>
                    <InspirationList inspiration={inspiration} />
                  </div>
                ))}
                <Button
                  title={view_all_text}
                  onClick={handleClickOnViewAll}
                  buttonType={FILLED_BUTTON_TYPE}
                  className={'view_all_text_button'}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="inspiration__outerWrapper">
            {inspirations.map(inspiration => (
              <div
                key={inspiration.id}
                onClick={() => handleClick(inspiration)}
              >
                <InspirationList inspiration={inspiration} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Inspiration;
